module.exports = __webpack_public_path__ + "img/Eye-close.86002c89.svg";